import { apiSlice } from "../../app/api/apiSlice";

export const loanDocsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		loanDocs: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/upload_attachment/",
				method: "POST",
				body: (() => {
					const formData = credentials?.formData;
					const userEmail = String(credentials?.user_email ?? "").trim();

					if (formData && userEmail && !formData.has("user_email")) {
						formData.append("user_email", userEmail);
					}

					return formData;
				})(),
			}),
		}),
	}),
});

export const { useLoanDocsMutation } = loanDocsApiSlice;
